/**
 * 版本记录
 */
import { VERSIONRECORD } from '../types';

export default {
    name: `${VERSIONRECORD}`,
    path: '/versionRecord',
    component: () => import(/* webpackChunkName: 'versionRecord' */ '@/views/versionRecord/'),
    redirect: { name: `${VERSIONRECORD}Index` },
    meta: {
        title: '版本记录',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${VERSIONRECORD}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'versionRecord' */ '@/views/versionRecord/home/Home.vue'),
        },
    ],
};
